<div class="wrap">
  <button class="close-button" (click)="closeDialog()"><span class="icon-close"></span></button>
  <header>
      <h3 class="heading">
        <span [ngClass]="data.card.cardType">
          <i [ngClass]="cardIcon"></i>
          {{ cardLabel }}
        </span>
        <span class="heading-text">{{ 'pages.userRecords.card.deleteCardDialog.header' | translate }}</span>
      </h3>
  </header>
  <div class="content">

    <div class="content-header">
      <span class="icon-warning"></span>
      <p>{{ 'pages.userRecords.card.deleteCardDialog.instruction' | translate }}</p>
    </div>
    
    <div class="user-card">
 
      <div class="user-infos">
        <div class="avatar-block">
          <img class="user-avatar" [src]="data.card.photo" alt="demo-avatar">
          
          <span class="user-name">
              {{ data.card.firstName }} {{ data.card.lastName }}
          </span>
        </div>
        <div class="infos-block">
          <p><span class="label">{{ 'common.fields.sex' | translate }}:</span> {{ 'common.' + data.card.sex | translate }}</p>
          <p><span class="label">{{ 'common.fields.birthdate' | translate }}:</span><span> {{ formatDate(data.card.birthDate) }}</span></p>
          <p><span class="label">{{ 'common.fields.address-short' | translate }}: </span>
            <span *ngIf="data.card.address.unit">{{ data.card.address.unit }} </span> {{ data.card.address.number }} {{ data.card.address.streetName }}, {{ data.card.address.city }}, {{ data.card.address.province }}, {{ data.card.address.postCode}}
          </p>
        </div>
      </div>
      
    </div>
      
  </div>
  <footer>
      <button class="bciti-button bciti-button-white" (click)="closeDialog()">{{ 'pages.userRecords.card.deleteCardDialog.button.back' | translate }}</button>
      <button 
        [disabled]="loading" 
        class="bciti-button bciti-button--red" 
        (click)="deleteUserCard()">
        <span *ngIf="!loading">{{ 'pages.userRecords.card.deleteCardDialog.button.delete' | translate }}</span>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      </button>
  </footer>
</div>